module.exports = __webpack_public_path__ + "img/minnie.2ad37a6c.jpg";